/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { useMemo, createContext } from "react";
import authAtom from "../atoms/auth.atom";
import appAtom from "../atoms/app.atom";

const { href: host } = window.location;
export const AxiosContext = createContext(null);
export const isStageEnv = host.includes("staging");
export const isTestEnv = host.includes("localhost") || host.includes("surge");
const isDevEnv = !process.env.NODE_ENV || process.env.NODE_ENV === "development" || isTestEnv;
export const apiURL = isDevEnv ? "http://84.247.136.197/api/app/v1/" : (isStageEnv ? "https://apistaging.estateplusng.com/api/app/v1/" : "https://api.estateplusng.com/api/app/v1/");
// export const apiURL = isDevEnv ? "http://84.247.136.197/api/app/v1/" : "https://default1.api.estateplusng.com/api/"; // API base URL is placed in between the quotes
export type HeaderType = {
  "Content-Type": string,
  Authorization?: string,
  Accept: string,
}

export default function AxiosContextProvider({ children }: any) {
  const { base_api } = useRecoilValue(appAtom);
  const { isLoggedIn, data } = useRecoilValue(authAtom);
  const baseURL = useMemo(() => (base_api || apiURL), [base_api]);
  const axiosInstance = useMemo(() => {
    const headers: HeaderType = { "Content-Type": "application/json", Accept: "application/json" };
    if (isLoggedIn) { headers.Authorization = `Bearer ${data?.token}` }
    return axios.create({ baseURL, headers });
  }, [isLoggedIn, data, baseURL]);

  return <AxiosContext.Provider value={axiosInstance as unknown as null}>{children}</AxiosContext.Provider>;
}